// Liqo — parsing PURO dei redirect/deep-link di autenticazione.
//
// Funzioni senza dipendenze da `window`, da Capacitor o da React: sono usate sia
// sul WEB (callback nella stessa scheda) sia in NATIVO (deep link `appUrlOpen`),
// e sono facilmente testabili in isolamento (vedi /app/tests/deeplink.test.js).

/**
 * Estrae il `session_id` del login Google (Emergent Auth) da un URL completo,
 * da un frammento hash (`#session_id=...`) o da una query string.
 * Ritorna il valore decodificato oppure `null`.
 */
export const parseSessionId = (input) => {
  if (!input) return null;
  const m = String(input).match(/session_id=([^&#]+)/);
  if (!m) return null;
  try {
    return decodeURIComponent(m[1]);
  } catch {
    return m[1];
  }
};

/**
 * Estrae i parametri del callback Open Banking (Enable Banking) da:
 * - un URL completo (`https://app/?code=...&state=...`)
 * - una query string (`?code=...` oppure `code=...`)
 * - un deep link nativo (`com.liqo.app://cb?code=...`)
 * Ritorna sempre `{ code, state, error }` (valori `null` se assenti).
 */
export const parseBankCallback = (input) => {
  const empty = { code: null, state: null, error: null };
  if (!input) return empty;
  let raw = String(input);
  // se è un URL/deep link completo, tieni solo la query
  const qIdx = raw.indexOf("?");
  if (qIdx >= 0) raw = raw.slice(qIdx + 1);
  // togli un eventuale frammento hash residuo
  const hIdx = raw.indexOf("#");
  if (hIdx >= 0) raw = raw.slice(0, hIdx);
  if (!raw) return empty;
  const params = new URLSearchParams(raw);
  return {
    code: params.get("code"),
    state: params.get("state"),
    error: params.get("error"),
  };
};

/**
 * Vero se la stringa rappresenta un callback bancario gestibile:
 * c'è un `code` (consenso riuscito) oppure un `error` con `state` (annullato).
 */
export const isBankCallback = (input) => {
  const { code, state, error } = parseBankCallback(input);
  return !!(code || (error && state));
};
